/**
 * Canonical Firestore schema for CP-3.
 *
 * Master-Brief A.3 is the single source of truth — every change here must
 * also be reflected in firestore.rules and the seed script. The voice-agent
 * (Python) mirrors these structures via Pydantic models.
 *
 * Timestamp values are typed as `FirestoreTimestamp` here so the same file
 * can be consumed by client code (`firebase/firestore`) and server code
 * (`firebase-admin/firestore`). Both SDKs satisfy the structural shape.
 */
/** Stable doc-IDs for the seeded plans. The Mollie + invoice pipelines
 *  look these up by ID, never by tier or by index. The naming is
 *  user-facing (admin sees them in the catalogue); legacy IDs
 *  `anfaenger_subscription` / `anfaenger_payg` / `advanced_subscription`
 *  are no longer written, but the readers below keep accepting them as
 *  fallbacks during the migration window. */
export const PRO_SUBSCRIPTION_PLAN_ID = 'pro_subscription';
export const PAYG_SUBSCRIPTION_PLAN_ID = 'payg_subscription';
export const ENTERPRISE_SUBSCRIPTION_PLAN_ID = 'enterprise_subscription';
export const ULTIMATE_SUBSCRIPTION_PLAN_ID = 'ultimate_subscription';
/** Legacy IDs from the previous naming scheme (Anfänger → Pro,
 *  Advanced → Enterprise). The seeder migrates docs at these IDs
 *  to the new names; loaders fall through to them while old data is
 *  still around. */
export const LEGACY_PLAN_IDS = {
    pro: 'anfaenger_subscription',
    payg: 'anfaenger_payg',
    enterprise: 'advanced_subscription',
};
/** Backwards-compat exports — kept so any downstream consumer still
 *  importing the old names compiles. New code should reference the
 *  PRO/PAYG/ENTERPRISE constants above. */
export const ANFAENGER_SUBSCRIPTION_PLAN_ID = PRO_SUBSCRIPTION_PLAN_ID;
export const ANFAENGER_PAYG_PLAN_ID = PAYG_SUBSCRIPTION_PLAN_ID;
export const ADVANCED_SUBSCRIPTION_PLAN_ID = ENTERPRISE_SUBSCRIPTION_PLAN_ID;
export const DEFAULT_TRIGGER_NOTIFICATION_CONFIG = {
    email: { enabled: false, templateId: '', sendDelay: 'immediate' },
    whatsapp: { enabled: false, templateId: '', sendDelay: 'immediate' },
    sms: { enabled: false, templateId: '', sendDelay: 'immediate' },
};
export const DEFAULT_ZAPIER_WEBHOOK_CONFIG = {
    ticketCreated: { enabled: false, url: '' },
    ticketStatusChanged: { enabled: false, url: '' },
    appointmentBooked: { enabled: false, url: '' },
};
export const DEFAULT_TICKET_SETTINGS = {
    enabled: true,
    recipientEmails: [],
    ccEmails: [],
    highPriorityRecipientEmails: [],
    urgentPriorityRecipientEmails: [],
    replyToEmail: '',
    fromName: 'CP-3 Voice',
    customerOutboundEnabled: false,
    customerEmailSignature: '',
    autoConfirmCallerOnCreate: false,
    autoConfirmTemplateId: '',
    ticketCreatedNotify: DEFAULT_TRIGGER_NOTIFICATION_CONFIG,
    appointmentBookedNotify: DEFAULT_TRIGGER_NOTIFICATION_CONFIG,
    zapierWebhooks: DEFAULT_ZAPIER_WEBHOOK_CONFIG,
    slaHours: { low: 72, normal: 24, high: 4, urgent: 1 },
    escalationEnabled: true,
    escalationAfterHours: 2,
    escalationRecipientEmails: [],
};
//# sourceMappingURL=types.js.map